// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileData_container__2U2O7"};